import Vue from 'vue'
import App from './App.vue'
import store from "./store/index.js";
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.use(ElementUI);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
